import { render, staticRenderFns } from "./URY.vue?vue&type=template&id=f41b9b50&scoped=true&"
import script from "./URY.vue?vue&type=script&lang=js&"
export * from "./URY.vue?vue&type=script&lang=js&"
import style0 from "./URY.vue?vue&type=style&index=0&id=f41b9b50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f41b9b50",
  null
  
)

export default component.exports